import React from 'react';
import Icon from 'atomic/icon';
import { CategoriesTreeInterface } from 'modules/shared/components/category-tree';
import { CategoryFull } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';
import { CategoryListingConfig } from 'modules/shared/modules/categories-shared/interfaces/category-listing-config.interface';
import { getProducerMainPageUrlBySlug } from 'modules/producers/helpers/producer-urls';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import classNames from 'classnames';

import './producer-category-tree-back-url.scss';

export interface ProducerCategoryTreeBackUrlProps {
    categoryTree: CategoriesTreeInterface;
    category?: CategoryFull<CategoryListingConfig>;
    producerName: string;
    producerSlug: string;
    getUrl: useProducerUrlType;
    isMarginBottom?: boolean;
}

const ProducerCategoryTreeBackUrl: React.FC<ProducerCategoryTreeBackUrlProps> = ({
    categoryTree,
    category,
    producerName,
    producerSlug,
    getUrl,
    isMarginBottom = true
}) => {
    if (!category || !categoryTree.parent) {
        return null;
    }

    let homeUrl = category.id !== categoryTree.parent.id
        ? { name: categoryTree.parent.name, url: categoryTree.parent.url }
        : { name: `strefy producenta ${producerName}`, url: getProducerMainPageUrlBySlug(producerSlug) };

    if ((category.id.charAt(0) === 'b' || category.id.charAt(0) === 'c') && category.parent) {
        homeUrl = {
            name: `${category.parent.name} ${producerName}`,
            url: getUrl({ categoryId: category.parent.id, categorySlug: category.parent.slug, producerSlug, page: 1 })
        };
    }

    return (
        <a
            href={homeUrl.url}
            className={classNames({
                'producer-category-tree-back-url': true,
                'producer-category-tree-back-url--mb': isMarginBottom
            })}
        >
            <Icon name="arrow-left" color="primary" size={20} />
            Wróć do {homeUrl.name}
        </a>
    );
};

export default ProducerCategoryTreeBackUrl;
